import React, { Component} from 'react';
import '../../App.css';
import FuncPrimersContent from '../FuncPrimersContent';

function FoundationFuncPrimers() {
    return (
      <>
          <FuncPrimersContent />
      </>
    )
  }

export default FoundationFuncPrimers;